import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TIPO_CQ_INIZIO, TipoCqInizio} from "../../../_helpers/TipoCqInizio";

@Component({
    selector: 'app-select-cq-tipo-inizio',
    templateUrl: './select-cq-tipo-inizio.component.html',
    styleUrls: ['./select-cq-tipo-inizio.component.scss'],
    standalone: false
})
export class SelectCqTipoInizioComponent  {
  @Input() tipoCqInizio: TipoCqInizio;
  @Input() label = 'Tipo controllo qualità';
  @Output() tipoCqInizioChange = new EventEmitter<TipoCqInizio>();
  tipoCqInizioItem = TIPO_CQ_INIZIO;
  selectTipoCqInizio = (e: SelectCustomEvent) => this.tipoCqInizioChange.emit(e.target.value);
}
